import bookingCycleMgr from "@services/bookingCycleMgr";
import { serviceManager } from "@services/workers";
import { api, state } from "@src/interfaces/interfaces";
// import config from "@src/utilities/config";
import { newBooking } from "@utils/general";
import type { NavigateFunction } from "react-router-dom";
import { formatSessionIdAsGuid } from "./guidFormatter";

export const handleNewBooking = async (
	navigate: NavigateFunction,
	accountCode: number,
	from: number,
	to: number,
	sessionId: string | null,
	eventId: number | null,
	callId: string | null,
) => {
	console.log(`🚀 [HANDLE_NEW_BOOKING] ENTRY - Called with params:`, {
		accountCode,
		from,
		to,
		sessionId,
		eventId,
		callId,
	});

	// Format session ID as GUID to ensure consistency across the application
	const formattedSessionId = sessionId ? formatSessionIdAsGuid(sessionId) : "";
	console.log(
		`📋 [HANDLE_NEW_BOOKING] Processing booking with session: ${sessionId} → ${formattedSessionId}`,
	);

	console.log(`🔧 [HANDLE_NEW_BOOKING] Setting booking cycle manager state...`);
	bookingCycleMgr.setBooking("call", accountCode, 0);
	bookingCycleMgr.setCurrentBookingSessionId(formattedSessionId);
	bookingCycleMgr.setCurrentBookingEventId(eventId || 0);

	// Get Five9 agent ID from Five9WebSocketTester authService
	const five9AgentId = window.five9Tester?.authService?.getSession()?.userId;
	console.log(`👤 [HANDLE_NEW_BOOKING] Agent ID resolution:`, {
		five9AgentId,
		fallbackUserId: state.UserId,
		finalAgentId: five9AgentId ? Number(five9AgentId) : state.UserId,
	});

	console.log(
		`📞 [HANDLE_NEW_BOOKING] Calling fetchGetCurrCallFive9 with callId: ${callId}, agentId: ${five9AgentId ? Number(five9AgentId) : state.UserId}`,
	);
	// if (!config.debug)
	try {
		console.log(`🚀 [HANDLE_NEW_BOOKING] About to call API...`);
		const apiResult = await api.fetchGetCurrentCallFive9(
			callId ? Number(callId) : 0, // Use callId if available, otherwise default to 0
			five9AgentId ? Number(five9AgentId) : state.UserId, // Use Five9 agent ID if available, fallback to WBS user ID
		);
		console.log(
			`✅ [HANDLE_NEW_BOOKING] fetchGetCurrCallFive9 completed successfully with result:`,
			apiResult,
		);
	} catch (error) {
		console.error(
			`❌ [HANDLE_NEW_BOOKING] fetchGetCurrCallFive9 failed:`,
			error,
		);
		throw error; // Re-throw to maintain original behavior
	}

	console.log(
		`📝 [HANDLE_NEW_BOOKING] Calling newBooking with callFrom: ${from}, accountCode: ${accountCode}`,
	);
	await newBooking({
		navigate,
		callFrom: from ? Number(from) : undefined,
		accountCode,
	});
	console.log(`✅ [HANDLE_NEW_BOOKING] newBooking completed successfully`);
	console.log(`🏁 [HANDLE_NEW_BOOKING] EXIT - All operations completed`);
};

export const setCallAsBooking = (
	payload: string,
	bookingState: string,
	bookingId: number,
) => {
	// Format session ID as GUID to ensure consistency across the application
	const formattedSessionId = formatSessionIdAsGuid(payload);
	console.log(
		`🔗 [SET_CALL_AS_BOOKING] Assigning session to booking: ${payload} → ${formattedSessionId}`,
	);

	serviceManager.sendMessageToWorker({
		serviceName: "PUZZEL_SYNC",
		serviceData: {
			origin: "MAIN_THREAD",
			command: "SET_CALL",
			payload: { iqSessionId: formattedSessionId, bookingState, bookingId },
		},
	});
};
